import React from 'react';

import { Switch, Route } from 'react-router-dom';

import Tabla from './tabla.js'
import Form from './Form.js'


export default (props) => {
    return(
        <Switch>
            <Route exact path='/cotizaciones' component={Tabla} />
            <Route exact path='/cotizaciones/form' component={Form} />
            <Route exact path='/cotizaciones/edit/:id' component={Form} />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/views/cotizaciones/index.js